import { Component, inject, Input } from '@angular/core';
import { EventsService, VariablesService } from 'src/app/shared/services';
import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url/safe-url.pipe';
import { NgIf } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'app-tutorial',
  standalone: true,
  imports: [NgIf, SafeUrlPipe, MatRippleModule],
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss']
})
export class TutorialComponent {
  readonly vars = inject(VariablesService);
  private readonly events = inject(EventsService);

  @Input() text;
  @Input() title;
  @Input() tutorialUrl;
  @Input() eventName;
  @Input() info_3;

  showTutorial;

  toggleTutorial(event) {
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('noscroll', event);
      this.showTutorial = event;
    }
  }

  event() {
    if (!this.eventName) { return; }
    const systemEvent = {
      eventName: this.eventName,
      info_3: this.info_3 || 'impact',
      page_name: this.vars.pageName
    };
    this.events.sendSystemEvent(systemEvent).subscribe(_ => _);
  }
}
